export default __webpack_public_path__ + "static/media/google-drive-step-3.15df3539.png";